import { ref, unref } from 'vue';
import { useEventListener } from "./useEventListener";
import fastdom from 'fastdom';

/**
 *
 */
export const useScroll = (elMayBeRef = window, cb) => {
    const x = ref(0);
    const y = ref(0);

    const update = () => {
        const el = unref(elMayBeRef);
        if (!el) return;

        if (typeof cb === 'function') cb();

        fastdom.measure(() => {
            x.value = el instanceof Window ? el.scrollX : el.scrollLeft;
            y.value = el instanceof Window ? el.scrollY : el.scrollTop;
        });
    };

    update();

    useEventListener(elMayBeRef, 'scroll', update, { passive: true });

    return {
        x,
        y,
    };
};
